var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoldenHorizontalStrip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 67.69 16.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Golden_Beryl_2);}.cls-15,.cls-2{opacity:0.35;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#Golden_Beryl_2-2);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#Bronze_2);}.cls-19,.cls-20,.cls-21,.cls-29,.cls-30,.cls-6,.cls-7,.cls-8{opacity:0.59;}.cls-6{fill:url(#Bronze_2-2);}.cls-7{fill:url(#Bronze_2-3);}.cls-8{fill:url(#Bronze_2-4);}.cls-9{fill:#353739;}.cls-10{fill:url(#linear-gradient-3);}.cls-11{fill:url(#linear-gradient-4);}.cls-12{fill:url(#linear-gradient-5);}.cls-13,.cls-25,.cls-31{opacity:0.5;}.cls-13{fill:url(#linear-gradient-6);}.cls-14{fill:url(#Golden_Beryl_2-3);}.cls-15{fill:url(#linear-gradient-7);}.cls-16{fill:url(#linear-gradient-8);}.cls-17{fill:url(#linear-gradient-9);}.cls-18{fill:url(#Bronze_2-5);}.cls-19{fill:url(#Bronze_2-6);}.cls-20{fill:url(#Bronze_2-7);}.cls-21{fill:url(#Bronze_2-8);}.cls-22{fill:url(#linear-gradient-10);}.cls-23{fill:url(#linear-gradient-11);}.cls-24{fill:url(#linear-gradient-12);}.cls-25{fill:url(#linear-gradient-13);}.cls-26{fill:url(#Golden_Beryl_2-4);}.cls-27{fill:#eada91;}.cls-28{fill:url(#Bronze_2-9);}.cls-29{fill:url(#Bronze_2-10);}.cls-30{fill:url(#Bronze_2-11);}.cls-31{fill:url(#linear-gradient-14);}.cls-32{fill:url(#linear-gradient-15);}.cls-33{fill:url(#linear-gradient-16);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Golden_Beryl_2",
    x1: 941.15,
    y1: -925.55,
    x2: 957.16,
    y2: -925.55,
    gradientTransform: "matrix(0, 1, 1, 0, 936.27, -941.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dbc766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f2f6de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#c6c9aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#a2a37f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#888860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#78774d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727146"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 956.55,
    y1: -912.49,
    x2: 956.55,
    y2: -934.94,
    gradientTransform: "matrix(0, 1, 1, 0, 936.27, -941.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#3a381d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a381d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Golden_Beryl_2-2",
    x1: 941.72,
    y1: -920.99,
    x2: 956.94,
    y2: -936.21,
    xlinkHref: "#Golden_Beryl_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 941.81,
    y1: -910.72,
    x2: 941.81,
    y2: -920.67,
    gradientTransform: "matrix(0, 1, 1, 0, 936.27, -941.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fff7d4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff7d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bronze_2",
    x1: 6.37,
    y1: 7.97,
    x2: 21.44,
    y2: 7.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#401617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#6b4c2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#a48955"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e4d3b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#957858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#957858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#804f2e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bronze_2-2",
    x1: 943.75,
    y1: -917.32,
    x2: 944.78,
    y2: -917.32,
    gradientTransform: "matrix(0, 1, 1, 0, 936.27, -941.15)",
    xlinkHref: "#Bronze_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bronze_2-3",
    x1: 1807.82,
    y1: 723.97,
    x2: 1808.61,
    y2: 723.97,
    gradientTransform: "matrix(-0.72, -0.69, -0.69, 0.72, 1819.76, 732.58)",
    xlinkHref: "#Bronze_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bronze_2-4",
    x1: 953.4,
    y1: -922.37,
    x2: 954.59,
    y2: -922.37,
    gradientTransform: "matrix(0, 1, 1, 0, 936.27, -941.15)",
    xlinkHref: "#Bronze_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2031.03,
    y1: 439.29,
    x2: 2031.03,
    y2: 437.96,
    gradientTransform: "translate(2046.26 450.18) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#221f1f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#221f1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 27.03,
    y1: 5.98,
    x2: 27.03,
    y2: 4.64,
    gradientTransform: "translate(-7.77 -0.93)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 950.12,
    y1: -973.2,
    x2: 949,
    y2: -974.32,
    gradientTransform: "matrix(0, 1, 1, 0, 987.25, -941.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#221f1f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#221f1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 11.91,
    y1: 13.41,
    x2: 11.91,
    y2: 14.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eada91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eada91",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Golden_Beryl_2-3",
    x1: 941.15,
    y1: 1112.34,
    x2: 957.16,
    y2: 1112.34,
    gradientTransform: "translate(1169.31 -941.15) rotate(90)",
    xlinkHref: "#Golden_Beryl_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 956.58,
    y1: 1125.94,
    x2: 956.58,
    y2: 1104.51,
    gradientTransform: "translate(1169.31 -941.15) rotate(90)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 941.72,
    y1: 1116.91,
    x2: 956.94,
    y2: 1101.69,
    gradientTransform: "translate(1169.31 -941.15) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff7d4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff7d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 941.84,
    y1: 1127.48,
    x2: 941.84,
    y2: 1116.97,
    gradientTransform: "translate(1169.31 -941.15) rotate(90)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bronze_2-5",
    x1: 46.25,
    y1: 7.97,
    x2: 61.32,
    y2: 7.97,
    xlinkHref: "#Bronze_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bronze_2-6",
    x1: 943.7,
    y1: 1120.57,
    x2: 944.89,
    y2: 1120.57,
    gradientTransform: "translate(1169.31 -941.15) rotate(90)",
    xlinkHref: "#Bronze_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bronze_2-7",
    x1: 333.29,
    y1: -682.74,
    x2: 334.1,
    y2: -682.74,
    gradientTransform: "translate(285.83 732.58) rotate(-43.65)",
    xlinkHref: "#Bronze_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bronze_2-8",
    x1: 953.43,
    y1: 1115.53,
    x2: 954.58,
    y2: 1115.53,
    gradientTransform: "translate(1169.31 -941.15) rotate(90)",
    xlinkHref: "#Bronze_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -57.87,
    y1: 439.34,
    x2: -57.87,
    y2: 437.96,
    gradientTransform: "matrix(1, 0, 0, -1, 110.34, 450.22)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 2115.87,
    y1: 6.04,
    x2: 2115.87,
    y2: 4.71,
    gradientTransform: "matrix(-1, 0, 0, 1, 2164.31, -0.97)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 950.25,
    y1: 1115.77,
    x2: 949.03,
    y2: 1114.55,
    gradientTransform: "translate(1169.31 -941.15) rotate(90)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 3588.74,
    y1: 13.41,
    x2: 3588.74,
    y2: 14.81,
    gradientTransform: "matrix(-1, 0, 0, 1, 3644.52, 0)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Golden_Beryl_2-4",
    x1: 33.75,
    y1: 0,
    x2: 33.75,
    y2: 16.01,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Golden_Beryl_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bronze_2-9",
    x1: 46.42,
    y1: 7.97,
    x2: 21.08,
    y2: 7.97,
    xlinkHref: "#Bronze_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bronze_2-10",
    x1: 953.41,
    y1: -902.54,
    x2: 954.6,
    y2: -902.54,
    gradientTransform: "matrix(0, 1, 1, 0, 936.27, -941.15)",
    xlinkHref: "#Bronze_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Bronze_2-11",
    x1: 943.71,
    y1: -902.54,
    x2: 944.81,
    y2: -902.54,
    gradientTransform: "matrix(0, 1, 1, 0, 936.27, -941.15)",
    xlinkHref: "#Bronze_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 33.75,
    y1: 13.41,
    x2: 33.75,
    y2: 14.81,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 41.52,
    y1: 5.98,
    x2: 41.52,
    y2: 4.64,
    gradientTransform: "translate(-7.77 -0.93)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 41.49,
    y1: 172.64,
    x2: 41.49,
    y2: 171.26,
    gradientTransform: "matrix(1, 0, 0, -1, -7.74, 183.52)",
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WATER-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Atk_Def_Panel",
    "data-name": "Atk/Def Panel"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Left_Frame",
    "data-name": "Left Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outer_Frame",
    "data-name": "Outer Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Base",
    className: "cls-1",
    d: "M21.44,0H14.72a.43.43,0,0,0-.32.14L.12,15.26A.45.45,0,0,0,.45,16h21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Right_SD",
    "data-name": "Right SD",
    className: "cls-2",
    d: "M.74,16a1.2,1.2,0,0,1-.49,0,1,1,0,0,1-.18-.19l2.32-1H21.44V16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Top_HL",
    "data-name": "Top HL",
    className: "cls-3",
    d: "M2.39,14.81,15.44,1.35,14.72,0s-.2,0-.26.07c-.27.31-.61.65-.61.65L.67,14.68a4.25,4.25,0,0,0-.6.66.39.39,0,0,0,0,.45Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_HL",
    "data-name": "Left HL",
    className: "cls-4",
    points: "15.44 1.35 14.72 0 21.44 0 21.44 1.35 15.44 1.35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Frame",
    "data-name": "Inner Frame"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Base-2",
    "data-name": "Base",
    className: "cls-5",
    points: "21.44 2.52 16.47 2.54 6.37 13.41 21.44 13.41 21.44 2.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_SD",
    "data-name": "Left SD",
    className: "cls-6",
    points: "21.44 3.71 17.07 3.71 16.47 2.54 21.44 2.52 21.44 3.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top_SD",
    "data-name": "Top SD",
    className: "cls-7",
    points: "6.37 13.41 16.47 2.53 17.07 3.71 9.02 12.23 6.37 13.41"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Right_SD-2",
    "data-name": "Right SD",
    className: "cls-8",
    points: "21.44 12.23 9.02 12.23 6.37 13.41 21.44 13.41 21.44 12.27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base-3",
    "data-name": "Base"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "21.44 12.23 9.02 12.23 17.07 3.72 21.44 3.71 21.44 12.23"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Bottom",
    className: "cls-10",
    points: "12.13 10.89 21.44 10.89 21.44 12.23 9.02 12.23 12.13 10.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top",
    className: "cls-11",
    points: "21.44 5.05 17.86 5.05 17.07 3.71 21.44 3.71 21.44 5.05"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "9.02 12.23 17.07 3.71 17.86 5.05 12.13 10.89 9.02 12.23"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "2.39 14.81 6.42 13.41 21.43 13.41 21.44 14.81 2.39 14.81"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Right_Frame",
    "data-name": "Right Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outer_Frame-2",
    "data-name": "Outer Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Base-4",
    "data-name": "Base",
    className: "cls-14",
    d: "M46.25,0H53a.45.45,0,0,1,.33.14L67.57,15.26a.44.44,0,0,1-.32.75h-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Right_SD-3",
    "data-name": "Right SD",
    className: "cls-15",
    d: "M67,16a1.21,1.21,0,0,0,.5,0,1.42,1.42,0,0,0,.18-.19l-2.32-1H46.25V16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Top_HL-2",
    "data-name": "Top HL",
    className: "cls-16",
    d: "M65.31,14.81,52.26,1.34,53,0s.21,0,.26.07c.27.31.61.65.61.65L67,14.68a4.25,4.25,0,0,1,.6.66.39.39,0,0,1,0,.45Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_HL-2",
    "data-name": "Left HL",
    className: "cls-17",
    points: "52.26 1.34 52.97 0 46.25 0 46.25 1.34 52.26 1.34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Frame-2",
    "data-name": "Inner Frame"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Base-5",
    "data-name": "Base",
    className: "cls-18",
    points: "46.25 2.52 51.23 2.54 61.32 13.41 46.25 13.41 46.25 2.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_SD-2",
    "data-name": "Left SD",
    className: "cls-19",
    points: "46.25 2.52 51.23 2.54 50.63 3.74 46.25 3.74 46.25 2.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top_SD-2",
    "data-name": "Top SD",
    className: "cls-20",
    points: "61.32 13.41 51.23 2.53 50.62 3.73 58.67 12.26 61.32 13.41"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Right_SD-4",
    "data-name": "Right SD",
    className: "cls-21",
    points: "46.25 12.26 58.67 12.26 61.32 13.41 46.25 13.41 46.25 12.27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-2",
    "data-name": "Fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base-6",
    "data-name": "Base"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "46.25 12.26 58.67 12.26 50.63 3.75 46.25 3.74 46.25 12.26"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Bottom-2",
    "data-name": "Bottom",
    className: "cls-22",
    points: "55.34 10.9 46.25 10.88 46.25 12.26 58.67 12.26 55.34 10.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top-2",
    "data-name": "Top",
    className: "cls-23",
    points: "46.25 5.08 49.84 5.08 50.63 3.74 46.25 3.74 46.25 5.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-24",
    points: "58.67 12.26 50.63 3.74 49.84 5.08 55.34 10.9 58.67 12.26"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "65.3 14.81 61.27 13.41 46.26 13.41 46.25 14.81 65.3 14.81"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Center_Bars",
    "data-name": "Center Bars"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 21.08,
    width: 25.34,
    height: 16.01
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Left_HL-3",
    "data-name": "Left HL",
    className: "cls-27",
    x: 33.08,
    y: -11.99,
    width: 1.34,
    height: 25.33,
    transform: "translate(34.43 -33.08) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Bars",
    "data-name": "Inner Bars"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M21.09,13.41H46.42m0-10.89H21.08M46.42,13.41V12.26L29,12.23H21.08v1.18M46.42,3.74V2.52H21.08V3.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Right_SD-5",
    "data-name": "Right SD",
    className: "cls-29",
    points: "46.42 13.41 21.08 13.41 21.08 12.23 46.42 12.26 46.42 13.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Left_SD-3",
    "data-name": "Left SD",
    className: "cls-30",
    points: "46.42 3.74 21.08 3.71 21.08 2.52 46.42 2.52 46.42 3.74"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "21.09 14.81 21.08 13.41 46.42 13.41 46.42 14.81 21.09 14.81"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fill-3",
    "data-name": "Fill"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Base-7",
    "data-name": "Base",
    className: "cls-9",
    points: "46.42 12.26 46.42 3.74 21.08 3.71 21.08 12.23 46.42 12.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Left_SD-4",
    "data-name": "Left SD",
    className: "cls-32",
    points: "46.42 5.05 21.08 5.05 21.08 3.71 46.42 3.74 46.42 5.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Right_SD-6",
    "data-name": "Right SD",
    className: "cls-33",
    points: "46.42 10.88 21.08 10.88 21.08 12.23 46.42 12.26 46.42 10.88"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldenHorizontalStrip);
export default __webpack_public_path__ + "static/media/goldenHorizontalStrip.0f30bb3a1554fa6e3e3367853f672a1e.svg";
export { ForwardRef as ReactComponent };